import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';

import VueResource from 'vue-resource';


import Footer from './Footer.vue';
import Header from './Header.vue';
import { routes} from './routes';
Vue.component('appSystemHeader',Header);
Vue.component('appSystemFooter',Footer);

Vue.use(VueRouter);

Vue.use(VueResource);

const router = new VueRouter({
  routes:routes,
  mode:'history',
  base: __dirname

});

new Vue({
  el: '#root',
  render: h => h(App),
  router:router
})


// WEBPACK FOOTER //
// ./src/main.js